import { useEffect, useMemo, useState } from 'react'

import LocalSessionService from '@maestro/commerce-blocks/session/localSessionService'
import SessionService from '@maestro/commerce-blocks/session/sessionService'

export const useLastSearches = (): {
  lastSearches: string[]
  addSearch: (searchTerm: string) => void
  removeSearch: (index: number) => void
} => {
  const sessionService: SessionService = useMemo(
    () => new LocalSessionService(),
    []
  )
  const [lastSearches, setLastSearches] = useState<string[]>(
    sessionService.getLastSearches()
  )

  useEffect(() => {
    setLastSearches(sessionService.getLastSearches())
  }, [sessionService])

  const addSearch = (searchTerm: string) => {
    const trimmedTerm = searchTerm.trim()

    if (trimmedTerm !== '' && !lastSearches.includes(trimmedTerm)) {
      sessionService.addSearch(searchTerm)
      setLastSearches([...sessionService.getLastSearches()])
    }
  }

  const removeSearch = (index: number) => {
    sessionService.removeSearch(index)
    setLastSearches([...sessionService.getLastSearches()])
  }

  return { lastSearches, addSearch, removeSearch }
}
